import { render, staticRenderFns } from "./addGarden.vue?vue&type=template&id=de888084&scoped=true&"
import script from "./addGarden.vue?vue&type=script&lang=js&"
export * from "./addGarden.vue?vue&type=script&lang=js&"
import style0 from "./addGarden.vue?vue&type=style&index=0&id=de888084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de888084",
  null
  
)

export default component.exports